define('ItemsearcherExtension', [
	'ItemsSearcher.Item.View',

	'Backbone',
	'jQuery',
	'Utils',
	'underscore'
], function (
	ItemsSearcherItemView,

	Backbone,
	jQuery,
	Utils,
	_
) {
	'use strict';

	_.extend(ItemsSearcherItemView.prototype, {
		getContext: _.wrap(ItemsSearcherItemView.prototype.getContext, function (fn) {
			var context = fn.apply(this, _.toArray(arguments).slice(1));
			var config = SC.CONFIGURATION.get("inventoryDisplay");
			var threshold = config.lowStockThreshold;
			context.threshold = threshold;

			return context;
		})
	});
});
